// Convocatorias 2025

export const convocatoria001 = [
  {
    nombre: "CONVOCATORIA 01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/CONVOCATORIA 01-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n1 = [
  {
    nombre: "BASES EA-913005999-N1-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/N1/BASES EA-913005999-N1-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N1-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/N1/JUNTA DE ACLARACIONES EA-913005999-N1-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACIÓN Y APERURA DE PROPUESTAS EA-913005999-N1-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/N1/ACTA DE APERTURA EA-913005999-N1-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO DIFERIDO EA-913005999-N1-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/N1/FALLO DIFERIDO EA-913005999-N1-2025 FLETES Y MANIOBRAS.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N1-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/N1/FALLO EA-913005999-N1-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n2 = [
  {
    nombre: "BASES EA-913005999-N2-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/N2/BASES EA-913005999-N2-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N2-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/N2/JUNTA DE ACLARACIONES EA-913005999-N2-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // {
  //   nombre: "PRESENTACIÓN Y APERURA DE PROPUESTAS EA-913005999-N2-2025",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/N2/ACTA DE APERTURA EA-913005999-N2-2025.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    nombre: "FALLO DIFERIDO EA-913005999-N2-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/N2/FALLO DIFERIDO EA-913005999-N2-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N2-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 01-2025/N2/FALLO EA-913005999-N2-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoriaLOP1 = [
  {
    nombre: "CONVOCATORIA 01-2025 OBRA",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 01-2025/CONVOCATORIA 01-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const lop1 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 01-2025/LOP-01/BASES DE LICITACIÓN CAASIM-HGO-L.O.P.-01-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATÁLOGO MUDO CAASIM-HGO-L.O.P.-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 01-2025/LOP-01/CATÁLOGO MUDO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PLANO CAASIM-HGO-L.O.P.-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 01-2025/LOP-01/PLANO.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 01-2025/LOP-01/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-01-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 01-2025/LOP-01/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-01-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  //FALLO CAASIM-HGO-L.O.P.-01-2025.pdf
  {
    nombre: "FALLO CAASIM-HGO-L.O.P.-01-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 01-2025/LOP-01/FALLO CAASIM-HGO-L.O.P.-01-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria002 = [
  {
    nombre: "CONVOCATORIA 02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/CONVOCATORIA 02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n3 = [
  {
    nombre: "BASES EA-913005999-N3-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N3/Bases EA-913005999-N3-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N3-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N3/JUNTA DE ACLARACIONES EA-913005999-N3-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N3-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N3/Acta de Presentación y Apertura de Proposiciones EA-913005999-N3-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N3-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N3/FALLO EA-913005999-N3-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n4 = [
  {
    nombre: "BASES EA-913005999-N4-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N4/Bases EA-913005999-N4-2025 Capacitación.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N4-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N4/JUNTA DE ACLARACIONES EA-913005999-N4-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N4-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N4/Acta de Presentación y Apertura de Proposiciones EA-913005999-N4-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N4-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N4/FALLO EA-913005999-N4-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n5 = [
  {
    nombre: "BASES EA-913005999-N5-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N5/Bases EA-913005999-N5-2025 Refacciones y Accesorios Menores, Otros bienes Muebles.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N5-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N5/JUNTA DE ACLARACIONES EA-913005999-N5-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N5-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N5/Acta de Presentación y Apertura de Proposiciones EA-913005999-N5-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N5-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N5/FALLO EA-913005999-N5-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n6 = [
  {
    nombre: "BASES EA-913005999-N6-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N6/Bases EA-913005999-N6-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N6-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N6/JUNTA DE ACLARACIONES EA-913005999-N6-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N6-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N6/Acta de Presentación y Apertura de Proposiciones EA-913005999-N6-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N6-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N6/FALLO EA-913005999-N6-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n7 = [
  {
    nombre: "BASES EA-913005999-N7-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N7/Bases EA-913005999-N7-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N7-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N7/JUNTA DE ACLARACIONES EA-913005999-N7-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N7-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N7/Acta de Presentación y Apertura de Proposiciones EA-913005999-N7-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N7-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 02-2025/N7/FALLO EA-913005999-N7-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria003 = [
  {
    nombre: "CONVOCATORIA 03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 03-2025/CONVOCATORIA 03-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n8 = [
  {
    nombre:
      "BASES EA-913005999-N8-2025 Refacciones y Accesorios Menores de Edificios",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 03-2025/N8/BASES EA-913005999-N8-2025 Refacciones y Accesorios Menores de Edificios.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N8-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 03-2025/N8/Junta de Aclaraciones EA-913005999-N8-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N8-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 03-2025/N8/Acta de Presentación y Apertura de Proposiciones EA-913005999-N8-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N8-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 03-2025/N8/Acta de Fallo EA-913005999-N8-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n9 = [
  {
    nombre:
      "BASES EA-913005999-N9-2025 Instalación, Reparación y Mantenimiento de Bienes Informáticos",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 03-2025/N9/BASES EA-913005999-N9-2025 Instalación, Reparación y Mantenimiento de Bienes Informáticos.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N9-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 03-2025/N9/Junta de Aclaraciones EA-913005999-N9-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N9-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 03-2025/N9/Acta de Presentación y Apertura de Proposiciones EA-913005999-N9-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO EA-913005999-N9-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 03-2025/N9/Acta de Fallo EA-913005999-N9-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria004 = [
  {
    nombre: "CONVOCATORIA 04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 04-2025/Convocatoria 04-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n10 = [
  {
    nombre: "BASES EA-913005999-N10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 04-2025/N10/Bases EA-913005999-N10-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 04-2025/N10/Acta de Junta de Aclaraciones EA-913005999-N10-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 04-2025/N10/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N10-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 04-2025/N10/FALLO EA-913005999-N10-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria005 = [
  {
    nombre: "CONVOCATORIA 05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/Convocatoria 05-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n11 = [
  {
    nombre: "BASES EA-913005999-N11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N11/Bases EA-913005999-N11-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N11/JUNTA DE ACLARACIONES EA-913005999-N11-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N11/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N11-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // {
  //   nombre: "FALLO EA-913005999-N11-2025",
  //   documentos: [
  //     {
  //       nombre: "Archivo",
  //       contenido: [
  //         {
  //           // excel: "www.google.com",
  //           pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N11/FALLO EA-913005999-N11-2025.pdf",
  //           // word: "www.google.com",
  //         },
  //       ],
  //     },
  //   ],
  // },
];

export const n12 = [
  {
    nombre: "BASES EA-913005999-N12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N12/Bases EA-913005999-N12-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N12/JUNTA DE ACLARACIONES EA-913005999-N12-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N12/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N12-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N12/ACTA DE FALLO LICITACION N-12.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n13 = [
  {
    nombre: "BASES EA-913005999-N13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/Bases EA-913005999-N13-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 1 - PARTIDA 1 ANVERSO RECIBO 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 1 ANVERSO RECIBO 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 2 - PARTIDA 1 REVERSO RECIBO 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 1 REVERSO RECIBO 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "ANEXO 3 - PARTIDA 2 FORMATO DE  SELLO ADHERIBLE DE SUSPENDIDO 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 2 FORMATO DE  SELLO ADHERIBLE DE SUSPENDIDO 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 4 - PARTIDA 3 INFORME DE INSTALACIÓN O SUSTITUCIÓN 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 3 INFORME DE INSTALACIÓN O SUSTITUCIÓN 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 5 - PARTIDA 4 contrato de prestacion de servicio  temporal",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 4 contrato de prestacion de servicio  temporal.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 6 - PARTIDA 5 contrato de prestacion de servicio",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 5 contrato de prestacion de servicio.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 7 - PARTIDA 6 FORMATO DE ACTA CIRCUNTANCIADA 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 6 FORMATO DE ACTA CIRCUNTANCIADA 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 8 - PARTIDA 7 ACTA CIRCUNSTANCIADA_saneamiento2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 7 ACTA CIRCUNSTANCIADA_saneamiento2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 9 - PARTIDA 8 AUTORIZACIÓN DE CARGOS con logo",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 8 AUTORIZACIÓN DE CARGOS con logo.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 10 - PARTIDA 9 FORMATO SOLICITUD DE ANÁLISIS con logo",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 9 FORMATO SOLICITUD DE ANÁLISIS con logo.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "ANEXO 11 - PARTIDA 10 SOLICITUD REPOSICIÓN DE DESCARGA con logo_saneamiento",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 10 SOLICITUD REPOSICIÓN DE DESCARGA con logo_saneamiento.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "ANEXO 12 - PARTIDA 11 SOLICITUD RENOVACIÓN DE DESCARGA con logo_saneamiento",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 11 SOLICITUD RENOVACIÓN DE DESCARGA con logo_saneamiento.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "ANEXO 13 - PARTIDA 12 SOLICITUD DE PERMISO DE DESCARGA con logo_saneamiento",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 12 SOLICITUD DE PERMISO DE DESCARGA con logo_saneamiento.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 14 - PARTIDA 17 FORMATO REPORTE DE USUARIO_laboratorio_2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 17 FORMATO REPORTE DE USUARIO_laboratorio_2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "ANEXO 15 - PARTIDA 18 FORMATO VERIFICACIÓN PIPAS AGUA POTABLE_laboratorio2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 18 FORMATO VERIFICACIÓN PIPAS AGUA POTABLE_laboratorio2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 16 - PARTIDA 19 CORTE DE CAJA 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDA 19 CORTE DE CAJA 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ANEXO 17 - PARTIDAS 13, 14, 15 Y 16 - 1.2.3.4.ETIQUETAS 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PARTIDAS 13, 14, 15 Y 16 - 1.2.3.4.ETIQUETAS 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/JUNTA DE ACLARACIONES EA-913005999-N13-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N13-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo diferido
  {
    nombre: "FALLO DIFERIDO EA-913005999-N13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/FALLO DIFERIDO EA-913005999-N13-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N13/ACTA DE FALLO LICITACION N-13.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n14 = [
  {
    nombre: "BASES EA-913005999-N14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N14/Bases EA-913005999-N14-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N14/JUNTA DE ACLARACIONES EA-913005999-N14-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N14/PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N14-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 05-2025/N14/ACTA DE FALLO LICITACION N-14.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoriaLOP2 = [
  {
    nombre: "CONVOCATORIA 05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 02-2025/CONVOCATORIA 02-2025 OBRA.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const lop2 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 02-2025/CAASIM-HGO-L.O.P.-02-2025/BASES CAASIM-HGO-L.O.P.-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for catalogo mudo y croquis de localizacion
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 02-2025/CAASIM-HGO-L.O.P.-02-2025/CATALOGO MUDO CAASIM-HGO-L.O.P.-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACION CAASIM-HGO-L.O.P.-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 02-2025/CAASIM-HGO-L.O.P.-02-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 02-2025/CAASIM-HGO-L.O.P.-02-2025/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 02-2025/CAASIM-HGO-L.O.P.-02-2025/PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  //  do it for fallo
  {
    nombre: "FALLO CAASIM-HGO-L.O.P.-02-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 02-2025/CAASIM-HGO-L.O.P.-02-2025/FALLO CAASIM-HGO-L.O.P.-02-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoriaLOP3 = [
  {
    nombre: "CONVOCATORIA 03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 03-2025/CONVOCATORIA 03-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const lop3 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 03-2025/CAASIM-HGO-L.O.P.-03-2025/BASES CAASIM-HGO-L.O.P.-03-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 03-2025/CAASIM-HGO-L.O.P.-03-2025/CATALOGO MUDO CAASIM-HGO-L.O.P.-03-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACION CAASIM-HGO-L.O.P.-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            dwg: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 03-2025/CAASIM-HGO-L.O.P.-03-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-03-2025.dwg",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 03-2025/CAASIM-HGO-L.O.P.-03-2025/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-03-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura de proposiciones
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-03-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 03-2025/CAASIM-HGO-L.O.P.-03-2025/PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-03-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoria006 = [
  {
    nombre: "CONVOCATORIA 06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/CONVOCATORIA 06-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n15 = [
  {
    nombre: "BASES EA-913005999-N15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N15/Bases EA-913005999-N15-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  //  do it for junta de aclaraciones
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N15/JUNTA DE ACLARACIONES EA-913005999-N15-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N15/ACTA APERTURA DE PROPOSICIONES EA-913005999-N15-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO EA-913005999-N15-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N15/FALLO EA-913005999-N15-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n16 = [
  {
    nombre: "BASES EA-913005999-N16-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N16/Bases EA-913005999-N16-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  //  do it for junta de aclaraciones
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N16-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N16/JUNTA DE ACLARACIONES EA-913005999-N16-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N16-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N16/ACTA APERTURA DE PROPOSICIONES EA-913005999-N16-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  //  do it for fallo
  {
    nombre: "FALLO EA-913005999-N16-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N16/FALLO EA-913005999-N16-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n17 = [
  {
    nombre: "BASES EA-913005999-N17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N17/Bases EA-913005999-N17-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  //  do it for junta de aclaraciones
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N17/JUNTA DE ACLARACIONES EA-913005999-N17-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N17/ACTA APERTURA DE PROPOSICIONES EA-913005999-N17-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO EA-913005999-N17-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N17/FALLO EA-913005999-N17-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n18 = [
  {
    nombre: "BASES EA-913005999-N18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N18/Bases EA-913005999-N18-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  //  do it for junta de aclaraciones
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N18/JUNTA DE ACLARACIONES EA-913005999-N18-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura
  {
    nombre: "PRESENTACION Y APERTURA EA-913005999-N18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N18/ACTA APERTURA DE PROPOSICIONES EA-913005999-N18-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for fallo
  {
    nombre: "FALLO EA-913005999-N18-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 06-2025/N18/FALLO EA-913005999-N18-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoriaLOP4 = [
  {
    nombre: "CONVOCATORIA 04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 04-2025/CONVOCATORIA OBRA 04-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const lop4 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 04-2025/CAASIM-HGO-L.O.P.-04-2025/BASES CAASIM-HGO-L.O.P.-04-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for catalogo mudo y croquis de localizacion
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 04-2025/CAASIM-HGO-L.O.P.-04-2025/CATALOGO MUDO CAASIM-HGO-L.O.P.-04-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACION CAASIM-HGO-L.O.P.-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            dwg: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 04-2025/CAASIM-HGO-L.O.P.-04-2025/CROQUIS DE LOCALIZACIÓN.dwg",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 04-2025/CAASIM-HGO-L.O.P.-04-2025/JUNTA DE ACLARACIONES CAASIM-HGO-L.O.P.-04-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-04-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA LOP 04-2025/CAASIM-HGO-L.O.P.-04-2025/PRESENTACION Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-04-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const convocatoria007 = [
  {
    nombre: "CONVOCATORIA 07-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/CONVOCATORIA 07-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n19 = [
  {
    nombre: "BASES EA-913005999-N19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N19/Bases EA-913005999-N19-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N19/JUNTA DE ACLARACIONES EA-913005999-N19-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  //  do it for presentacion y apertura
  {
    nombre: "PRESENTACION Y APERTURA DE PROPOSICIONES EA-913005999-N19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N19/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N19-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N19-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N19/FALLO EA-913005999-N19-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n20 = [
  {
    nombre: "BASES EA-913005999-N20-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/Bases EA-913005999-N20-2025 Formas Valoradas (Segundo Procedimiento).pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 1 ANVERSO RECIBO 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 1 ANVERSO RECIBO 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 1 REVERSO RECIBO 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 1 REVERSO RECIBO 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 2 FORMATO DE  SELLO ADHERIBLE DE SUSPENDIDO 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 2 FORMATO DE  SELLO ADHERIBLE DE SUSPENDIDO 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 3 INFORME DE INSTALACIÓN O SUSTITUCIÓN 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 3 INFORME DE INSTALACIÓN O SUSTITUCIÓN 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 4 contrato de prestacion de servicio  temporal",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 4 contrato de prestacion de servicio  temporal.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 5 contrato de prestacion de servicio",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 5 contrato de prestacion de servicio.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 6 FORMATO DE ACTA CIRCUNTANCIADA 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 6 FORMATO DE ACTA CIRCUNTANCIADA 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 7 ACTA CIRCUNSTANCIADA_saneamiento2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 7 ACTA CIRCUNSTANCIADA_saneamiento2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 8 AUTORIZACIÓN DE CARGOS con logo",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 8 AUTORIZACIÓN DE CARGOS con logo.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 9 FORMATO SOLICITUD DE ANÁLISIS con logo",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 9 FORMATO SOLICITUD DE ANÁLISIS con logo.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 10 SOLICITUD REPOSICIÓN DE DESCARGA con logo_saneamiento",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 10 SOLICITUD REPOSICIÓN DE DESCARGA con logo_saneamiento.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 11 SOLICITUD RENOVACIÓN DE DESCARGA con logo_saneamiento",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 11 SOLICITUD RENOVACIÓN DE DESCARGA con logo_saneamiento.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 12 SOLICITUD DE PERMISO DE DESCARGA con logo_saneamiento",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 12 SOLICITUD DE PERMISO DE DESCARGA con logo_saneamiento.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 13, 14, 15 Y 16 - 1.2.3.4.ETIQUETAS 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 13, 14, 15 Y 16 - 1.2.3.4.ETIQUETAS 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 17 FORMATO REPORTE DE USUARIO_laboratorio_2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 17 FORMATO REPORTE DE USUARIO_laboratorio_2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PARTIDA 18 FORMATO VERIFICACIÓN PIPAS AGUA POTABLE_laboratorio2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 18 FORMATO VERIFICACIÓN PIPAS AGUA POTABLE_laboratorio2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "PARTIDA 19 CORTE DE CAJA 2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PARTIDA 19 CORTE DE CAJA 2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N20-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/JUNTA DE ACLARACIONES EA-913005999-N20-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura
  {
    nombre: "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N20-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N20-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N20-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N20/FALLO EA-913005999-N20-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n21 = [
  {
    nombre: "BASES EA-913005999-N21-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N21/Bases EA-913005999-N21-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // do it for junta de aclaraciones
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N21-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N21/JUNTA DE ACLARACIONES EA-913005999-N21-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  // do it for presentacion y apertura
  {
    nombre: "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N21-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N21/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N21-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N21-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 07-2025/N21/FALLO EA-913005999-N21-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const convocatoria008 = [
  {
    nombre: "CONVOCATORIA 08-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/CONVOCATORIA 08-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n22 = [
  {
    nombre: "BASES EA-913005999-N22-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N22/BASES EA-913005999-N22-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N22-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N22/JUNTA DE ACLARACIONES EA-913005999-N22-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA LPN EA-913005999-N22-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N22/ACTA DE APERTURA LPN EA-913005999-N22-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO LPN EA-913005999-N22-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N22/ACTA DE FALLO LPN EA-913005999-N22-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n23 = [
  {
    nombre: "BASES EA-913005999-N23-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N23/BASES EA-913005999-N23-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N23-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N23/JUNTA DE ACLARACIONES EA-913005999-N23-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA LPN EA-913005999-N23-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N23/ACTA DE APERTURA LPN EA-913005999-N23-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO LPN EA-913005999-N23-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N23/ACTA DE FALLO LPN EA-913005999-N23-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n24 = [
  {
    nombre: "BASES EA-913005999-N24-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N24/BASES EA-913005999-N24-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N24-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N24/JUNTA DE ACLARACIONES EA-913005999-N24-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA LPN EA-913005999-N24-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N24/ACTA DE APERTURA LPN EA-913005999-N24-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO LPN EA-913005999-N24-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 08-2025/N24/ACTA DE FALLO LPN EA-913005999-N24-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const convocatoriaMult05 = [
  {
    nombre: "CONVOCATORIA MULTIPLE 05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CONVOCATORIA MULTIPLE 05-2025 .pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const lop5 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-05-2025/BASES CAASIM-HGO-L.O.P.-05-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-05-2025/CATALOGO MUDO CAASIM-HGO-L.O.P.-05-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-05-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-05-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACALARACIONES CAASIM-HGO-L.O.P.-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-05-2025/JUNTA DE ACALARACIONES CAASIM-HGO-L.O.P.-05-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-05-2025/PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-05-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-L.O.P.-05-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-05-2025/FALLO CAASIM-HGO-L.O.P.-05-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const lop6 = [
  {
    nombre: "BASES CAASIM-HGO-L.O.P.-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-06-2025/BASES CAASIM-HGO-L.O.P.-06-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CATALOGO MUDO CAASIM-HGO-L.O.P.-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-06-2025/CATALOGO MUDO CAASIM-HGO-L.O.P.-06-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-06-2025/CROQUIS DE LOCALIZACIÓN CAASIM-HGO-L.O.P.-06-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACALARACIONES CAASIM-HGO-L.O.P.-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-06-2025/JUNTA DE ACALARACIONES CAASIM-HGO-L.O.P.-06-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre:
      "PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-06-2025/PRESENTACIÓN Y APERTURA DE PROPOSICIONES CAASIM-HGO-L.O.P.-06-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO CAASIM-HGO-L.O.P.-06-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA MULTIPLE 05-2025/CAASIM-HGO-L.O.P.-06-2025/FALLO CAASIM-HGO-L.O.P.-06-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const convocatoria009 = [
  {
    nombre: "CONVOCATORIA 09-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 09-2025/CONVOCATORIA 09-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n25 = [
  {
    nombre: "BASES EA-913005999-N25-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 09-2025/N25/BASES EA-913005999-N25-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N25-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 09-2025/N25/JUNTA DE ACLARACIONES EA-913005999-N25-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N25-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 09-2025/N25/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N25-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N25-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 09-2025/N25/FALLO EA-913005999-N25-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const convocatoria010 = [
  {
    nombre: "CONVOCATORIA 10-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 10-2025/CONVOCATORIA 10-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
];

export const n26 = [
  {
    nombre: "BASES EA-913005999-N26-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 10-2025/N26/BASES EA-913005999-N26-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "Junta de Aclaraciones EA-913005999-N26-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 10-2025/N26/Junta de Aclaraciones EA-913005999-N26-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  // Acto de Presentación y Apertura de Proposiciones EA-913005999-N26-2025
  {
    nombre:
      "Acto de Presentación y Apertura de Proposiciones EA-913005999-N26-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 10-2025/N26/Acto de Presentación y Apertura de Proposiciones EA-913005999-N26-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N26-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 10-2025/N26/FALLO EA-913005999-N26-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const convocatoria011 = [
  {
    nombre: "CONVOCATORIA 11-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/CONVOCATORIA 11-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n27 = [
  {
    nombre: "BASES EA-913005999-N27-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N27/BASES EA-913005999-N27-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N27-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N27/JUNTA DE ACLARACIONES EA-913005999-N27-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N27-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N27/APERTURA EA-913005999-N27-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N27-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N27/FALLO EA-913005999-N27-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n28 = [
  {
    nombre: "BASES EA-913005999-N28-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N28/BASES EA-913005999-N28-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N28-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N28/JUNTA DE ACLARACIONES EA-913005999-N28-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N28-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N28/APERTURA EA-913005999-N28-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N28-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N28/FALLO EA-913005999-N28-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n29 = [
  {
    nombre: "BASES EA-913005999-N29-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N29/BASES EA-913005999-N29-2025.pdf",
            // word: "www.google.com",
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N29-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N29/JUNTA DE ACLARACIONES EA-913005999-N29-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N29-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N29/APERTURA EA-913005999-N29-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  //
  {
    nombre: "FALLO EA-913005999-N29-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 11-2025/N29/FALLO EA-913005999-N29-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const convocatoria012 = [
  {
    nombre: "CONVOCATORIA 12-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 12-2025/CONVOCATORIA 12-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n30 = [
  {
    nombre: "BASES EA-913005999-N30-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 12-2025/N30/BASES EA-913005999-N30-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE JUNTA DE ACLARACIONES EA-913005999-N30-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 12-2025/N30/ACTA DE JUNTA DE ACLARACIONES EA-913005999-N30-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA DE PROPUESTAS LPN EA-913005999-N30-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 12-2025/N30/ACTA DE APERTURA DE PROPUESTAS LPN EA-913005999-N30-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO EA913005999-N30-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 12-2025/N30/ACTA DE FALLO EA913005999-N30-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n31 = [
  {
    nombre: "BASES EA-913005999-N31-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 12-2025/N31/BASES EA-913005999-N31-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE JUNTA DE ACLARACIONES EA-913005999-N31-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 12-2025/N31/ACTA DE JUNTA DE ACLARACIONES EA-913005999-N31-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE APERTURA DE PROPUESTAS LPN EA-913005999-N31-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 12-2025/N31/ACTA DE APERTURA DE PROPUESTAS LPN EA-913005999-N31-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "ACTA DE FALLO EA913005999-N31-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 12-2025/N31/ACTA DE FALLO EA913005999-N31-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const convocatoria013 = [
  {
    nombre: "CONVOCATORIA 13-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/CONVOCATORIA 13-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n32 = [
  {
    nombre: "Bases EA-913005999-N32-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N32/Bases EA-913005999-N32-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N32-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N32/JUNTA DE ACLARACIONES EA-913005999-N32-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N32-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N32/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N32-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO N32",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N32/FALLO N32.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n33 = [
  {
    nombre: "Bases EA-913005999-N33-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N33/Bases EA-913005999-N33-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N33-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N33/JUNTA DE ACLARACIONES EA-913005999-N33-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N33-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N33/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N33-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO N33",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N33/FALLO N33.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n34 = [
  {
    nombre: "Bases EA-913005999-N34-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N34/Bases EA-913005999-N34-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N34-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N34/JUNTA DE ACLARACIONES EA-913005999-N34-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N34-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N34/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N34-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO N34",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N34/FALLO N34.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n35 = [
  {
    nombre: "Bases EA-913005999-N35-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N35/Bases EA-913005999-N35-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA DE ACLARACIONES EA-913005999-N35-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N35/JUNTA DE ACLARACIONES EA-913005999-N35-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N35-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N35/PRESENTACIÓN Y APERTURA DE PROPOSICIONES EA-913005999-N35-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO N35",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 13-2025/N35/FALLO N35.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const convocatoria014 = [
  {
    nombre: "CONVOCATORIA 14-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/CONVOCATORIA 14-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
];

export const n36 = [
  {
    nombre: "BASES EA-913005999-N36-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N36/BASES EA-913005999-N36-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N36-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N36/JUNTA ACLARACIONES EA-913005999-N36-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N36-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N36/APERTURA EA-913005999-N36-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N36-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N36/FALLO EA-913005999-N36-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n37 = [
  {
    nombre: "BASES EA-913005999-N37-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N37/BASES EA-913005999-N37-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N37-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N37/JUNTA ACLARACIONES EA-913005999-N37-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N37-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N37/APERTURA EA-913005999-N37-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N37-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N37/FALLO EA-913005999-N37-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n38 = [
  {
    nombre: "BASES EA-913005999-N38-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N38/BASES EA-913005999-N38-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N38-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N38/JUNTA ACLARACIONES EA-913005999-N38-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N38-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N38/APERTURA EA-913005999-N38-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N38-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N38/FALLO EA-913005999-N38-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n39 = [
  {
    nombre: "BASES EA-913005999-N39-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N39/BASES EA-913005999-N39-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N39-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N39/JUNTA ACLARACIONES EA-913005999-N39-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N39-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N39/APERTURA EA-913005999-N39-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N39-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N39/FALLO EA-913005999-N39-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n40 = [
  {
    nombre: "BASES EA-913005999-N40-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N40/BASES EA-913005999-N40-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N40-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N40/JUNTA ACLARACIONES EA-913005999-N40-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N40-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N40/APERTURA EA-913005999-N40-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N40-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N40/FALLO EA-913005999-N40-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n41 = [
  {
    nombre: "BASES EA-913005999-N41-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N41/BASES EA-913005999-N41-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N41-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N41/JUNTA ACLARACIONES EA-913005999-N41-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N41-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N41/APERTURA EA-913005999-N41-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N41-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N41/FALLO EA-913005999-N41-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n42 = [
  {
    nombre: "BASES EA-913005999-N42-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N42/BASES EA-913005999-N42-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N42-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N42/JUNTA ACLARACIONES EA-913005999-N42-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N42-2025_REANUDACIÓN",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N42/JUNTA ACLARACIONES EA-913005999-N42-2025_REANUDACIÓN.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N42-2025_2DA. REANUDACIÓN",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N42/JUNTA ACLARACIONES EA-913005999-N42-2025_2DA. REANUDACIÓN.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N42-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N42/APERTURA EA-913005999-N42-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N42-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N42/FALLO EA-913005999-N42-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n43 = [
  {
    nombre: "BASES EA-913005999-N43-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N43/BASES EA-913005999-N43-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N43-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N43/JUNTA ACLARACIONES EA-913005999-N43-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N43-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N42/APERTURA EA-913005999-N43-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N43-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N42/FALLO EA-913005999-N43-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n44 = [
  {
    nombre: "BASES EA-913005999-N44-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N44/BASES EA-913005999-N44-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N44-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N44/JUNTA ACLARACIONES EA-913005999-N44-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N44-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N43/APERTURA EA-913005999-N44-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n45 = [
  {
    nombre: "BASES EA-913005999-N45-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N45/BASES EA-913005999-N45-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N45-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N45/JUNTA ACLARACIONES EA-913005999-N45-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N45-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N45/APERTURA EA-913005999-N45-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N45-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N45/FALLO EA-913005999-N45-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n46 = [
  {
    nombre: "BASES EA-913005999-N46-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N46/BASES EA-913005999-N46-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N46-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N46/JUNTA ACLARACIONES EA-913005999-N46-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N46-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N46/APERTURA EA-913005999-N46-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N46-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N46/FALLO EA-913005999-N46-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n47 = [
  {
    nombre: "BASES EA-913005999-N47-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N47/BASES EA-913005999-N47-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N47-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N47/JUNTA ACLARACIONES EA-913005999-N47-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N47-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N47/APERTURA EA-913005999-N47-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N47-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N47/FALLO EA-913005999-N47-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n48 = [
  {
    nombre: "BASES EA-913005999-N48-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N48/BASES EA-913005999-N48-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N48-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N48/JUNTA ACLARACIONES EA-913005999-N48-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N48-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N48/APERTURA EA-913005999-N48-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N48-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N48/FALLO EA-913005999-N48-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n49 = [
  {
    nombre: "BASES EA-913005999-N49-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N49/BASES EA-913005999-N49-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N49-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N49/JUNTA ACLARACIONES EA-913005999-N49-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N49-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N49/APERTURA EA-913005999-N49-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N49-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N49/FALLO EA-913005999-N49-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];

export const n50 = [
  {
    nombre: "BASES EA-913005999-N50-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N50/BASES EA-913005999-N50-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "JUNTA ACLARACIONES EA-913005999-N50-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N50/JUNTA ACLARACIONES EA-913005999-N50-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "APERTURA EA-913005999-N50-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N50/APERTURA EA-913005999-N50-2025.pdf",
            // new: true,
          },
        ],
      },
    ],
  },
  {
    nombre: "FALLO EA-913005999-N50-2025",
    documentos: [
      {
        nombre: "Archivo",
        contenido: [
          {
            // excel: "www.google.com",
            pdf: "/CAASIM/licitaciones/2025/CONVOCATORIA 14-2025/N50/FALLO EA-913005999-N50-2025.pdf",
            new: true,
          },
        ],
      },
    ],
  },
];
